// src/pages/Reports.js
import React from 'react';
import { Link } from 'react-router-dom';
import PageWrapper from '../components/PageWrapper';
import {
  ClipboardDocumentListIcon,
  ArrowRightIcon,
} from '@heroicons/react/24/outline';

const reportCards = [
  {
    title: 'Rental Listings Report',
    description:
      'View all active rental listings with tenant names and current balance. Filter to show only overdue listings where the tenant is in arrears.',
    href: '/reports/rental-listings',
    icon: ClipboardDocumentListIcon,
    colour: 'emerald',
  },
  // Future reports can be added here
];

const colourMap = {
  emerald: {
    bg: 'bg-emerald-50',
    icon: 'text-emerald-600',
    border: 'border-emerald-100',
    hover: 'hover:border-emerald-300 hover:bg-emerald-50',
    arrow: 'text-emerald-500',
  },
  blue: {
    bg: 'bg-blue-50',
    icon: 'text-blue-600',
    border: 'border-blue-100',
    hover: 'hover:border-blue-300 hover:bg-blue-50',
    arrow: 'text-blue-500',
  },
};

const Reports = () => {
  return (
    <PageWrapper>
      {/* Page header */}
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900">Reports</h1>
        <p className="mt-1 text-sm text-gray-500">
          Select a report to view detailed information about your rental portfolio.
        </p>
      </div>

      {/* Report cards grid */}
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {reportCards.map((card) => {
          const colours = colourMap[card.colour] || colourMap.emerald;
          return (
            <Link
              key={card.href}
              to={card.href}
              className={`
                group relative flex flex-col rounded-xl border bg-white p-6 shadow-sm transition-all
                ${colours.hover} hover:shadow-md
              `}
            >
              {/* Icon */}
              <div className={`mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg ${colours.bg}`}>
                <card.icon className={`h-6 w-6 ${colours.icon}`} />
              </div>

              {/* Content */}
              <h3 className="text-base font-semibold text-gray-900 group-hover:text-gray-700">
                {card.title}
              </h3>
              <p className="mt-2 flex-1 text-sm text-gray-500 leading-relaxed">
                {card.description}
              </p>

              {/* Arrow */}
              <div className={`mt-4 flex items-center text-sm font-medium ${colours.arrow}`}>
                View report
                <ArrowRightIcon className="ml-1 h-4 w-4 transition-transform group-hover:translate-x-1" />
              </div>
            </Link>
          );
        })}
      </div>
    </PageWrapper>
  );
};

export default Reports;

